import VueI18n from 'vue-i18n';
import { RawLocation, Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { ShareContentPanelState } from '@front-app/modules/group/util/shareContentModal';
import { DEFAULT_GROUP_FILTERS, GroupFilter, GroupSort } from '@front-app/views/home/groups/GroupEnum';
import { ContentQueryParam } from '@front-app/modules/content/routing/params';
import { stringToEnum } from '@front-app/util/enum';
import { PhoenixRouteConfig } from '../Model';
import { getAsArray, getSingleParam } from '../util/getFromRequest';
import { GroupListQuery } from '../util/groupListQuery';
import { main } from './group/main';
import { content } from './group/content';
import { events } from './group/event';
import { custom } from './group/custom';
import { learning } from './group/learning';
import { admin } from './group/admin';

export const groupRoutes: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('page.title.groups.all-my-groups') as string;
			},
			trappRoute(): string {
				return '/fgfs.shtml';
			},
		},
		path: 'groups/',
		name: Routes.GROUPS,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			const requestedFilters = (getAsArray(route.query[GroupListQuery.FILTERS]) as GroupFilter[])
				.filter((filter) => Object.values(GroupFilter).includes(filter));
			const currentAccessFilters = requestedFilters.length > 0 ? requestedFilters : DEFAULT_GROUP_FILTERS;
			const currentSort = Object.values(GroupSort)
				.includes(route.query[GroupListQuery.SORT] as GroupSort) ? route.query[GroupListQuery.SORT] : GroupSort.ALPHABETICAL;
			return {
				currentAccessFilters,
				currentSort,
			};
		},
		component: () => import(/* webpackChunkName: "groups" */ '@front-app/views/home/Groups.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('groups.group') as string;
			},
			loginRoute(to: Route): RawLocation {
				return {
					name: Routes.GROUP_LOGIN,
					params: to.params,
				};
			},
		},
		path: 'groups/:groupId/',
		name: Routes.GROUP,
		redirect: { name: Routes.GROUP_MAIN },
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				groupId: route.params.groupId,
				email: getSingleParam(route.query.email),
				inviteId: route.query.inviteId,
				shareContentPanelState: stringToEnum(route.query.share, ShareContentPanelState, ShareContentPanelState.CLOSED),
				shareToDiscussionId: route.query.shareToDiscussionId,
				startDiscussion: route.query.startDiscussion === 'true',
				contentIdToEdit: route.query[ContentQueryParam.EDIT_CONTENT],
			};
		},
		component: () => import(/* webpackChunkName: "group" */ '@front-app/views/home/Group.vue'),
		children: [
			...main,
			...content,
			...events,
			...custom,
			...learning,
			...admin,
		],
	},
];
